/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

function ComplianceInformation() {
  return (
    <MKBox component="section" py={12}>
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={12} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            <DefaultInfoCard
              //icon="info"
              title="Compliance"
              description={
                <>
                  <p>The Chief Electoral Officer is responsible for ensuring that election officers enforce the&nbsp;<em>Elections Act</em>&nbsp;through fairness, impartiality and compliance. The CEO may investigate matters that may constitute an offence under the <em>Act</em>.&nbsp; After the investigation, the CEO may choose to refer the matter to the Director of Public Prosecutions, enter into a compliance agreement with the person (referred to as the contracting party in Section 294 of the <em>Act</em>), issue a notice of non-compliance, or decide to take no further action.</p>
                  <br /><p>The Chief Electoral Officer has the authority to enter into a compliance agreement with anyone who the CEO believes on reasonable grounds has committed, is about to commit or is likely to commit an act or omission that would constitute an offence under the <em>Act</em>. Alternatively, if he has reasonable grounds to believe the matter is relatively minor and will not be repeated, the CEO may only send a notice of non-compliance to the person.</p>
                  <br /><p>A compliance agreement is an agreement between the Chief Electoral Officer and the person who has breached the <em>Act</em>. The compliance agreement sets out terms and conditions that CEO considers necessary to ensure the person’s compliance with the <em>Act</em>. A compliance agreement normally includes a statement in which the person admits responsibility for the act or omission that constitutes the offence under the <em>Act</em>. The admission of responsibility does not constitute a conviction by a court of law and does not create a criminal record.</p>
                  <br /><p>A notice of compliance agreement includes the name of the person who has breached the <em>Act</em>, the act or omission in question. A summary of the compliance agreement is made public as required by the <em>Act</em> and in the interest of transparency.</p>
                  <br /><p>A notice of non-compliance notifies a person of non-compliances (or breach) of the <em>Act</em>. The Chief Electoral Officer has the authority to issue a notice of non-compliance with anyone who the CEO believes on reasonable grounds has committed, is about to commit or is likely to commit an act or omission that would constitute an offence under the <em>Act</em>. These letters and information regarding the letter are not published.</p><br /><br />
                  <ul style={{ paddingLeft: "40px" }}>
                    <li><a href=" /files/Compliance/20230803_Statement_LiberalPartyOrder_FINAL.pdf"> Elections Nova Scotia Statement (Preston By-election) - August 3, 2023.</a></li>
                    <li><a href=" /files/Compliance/NoticeofComplianceAgreement_EDA_Preston_Nov22.pdf">Notice of Compliance Agreement – Kerry Foss, Liberal Electoral District Association Preston - November 2022.</a></li>
                  </ul>
                </>
              }
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default ComplianceInformation;
